import {createSelector, MemoizedSelector} from '@ngrx/store';
import {SueloCore, suelosAdapter, SuelosState} from './suelos.state';

import {FeaturesState, selectFeatures} from '../../../features.state';

export const getError = (state: SuelosState): any => state.error;

export const getIsLoading = (state: SuelosState): boolean =>
  state.isLoading;

export const selectSuelosState = createSelector(selectFeatures,
  (state: FeaturesState) => state.suelos
);

export const selectAllSuelos: (state: object) => SueloCore[] = suelosAdapter.getSelectors(selectSuelosState)
  .selectAll;

export const selectSueloById = (id: string) =>
  createSelector(
    selectAllSuelos,
    (allSuelos: SueloCore[]) => {
      if (allSuelos) {
        return allSuelos.find(s => s.sueloId === id);
      } else {
        return null;
      }
    }
  );

export const selectSuelosById = (ids: string[]) =>
  createSelector(
    selectAllSuelos,
    (allSuelos: SueloCore[]) => {
      if (allSuelos) {
        return allSuelos.filter(s => ids.indexOf(s.sueloId) >= 0);
      } else {
        return [];
      }
    }
  );

export const selectSuelosError: MemoizedSelector<object, any> = createSelector(
  selectSuelosState,
  getError
);

export const selectSuelosIsLoading: MemoizedSelector<object, boolean> = createSelector(
  selectSuelosState,
  getIsLoading
);
